'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Path = require('./Path');

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var Vector = function Vector(x, y) {
  _classCallCheck(this, Vector);

  this.type = _Path.PATH.VECTOR;
  this.x = x;
  this.y = y;

  if (process.env.NODE_ENV !== 'production') {
    if (isNaN(x)) {
      console.error('Invalid x value given for Vector');
    }

    if (isNaN(y)) {
      console.error('Invalid y value given for Vector');
    }
  }
};

exports.default = Vector;